import React from 'react'

function Article(props) {
  return (
    <article>
    <h3>zayn, sin, shin</h3>
    <p>Let's practice these!</p>
    </article>
  )
}

export default Article
